import React from "react";
import CommonGrid from "./CommonGrid";
import { ColumnType } from "../../../../components/Grid/constants";
import {
  InspectionResult,
  InspectionResultEnum,
  InspectionResultSymbol,
  InspectionTypeEnum
} from "../../enum";
import { FilterOperation } from "../../../../components/Grid/dataProvider";

const INSPECTION_GRID_BASE_COLUMNS = [
  {
    field: 'type.id',
    displayField: 'type',
    filterItems: InspectionTypeEnum,
    label: 'Typ kontroly',
    enum: InspectionTypeEnum,
    type: ColumnType.ENUM,
    width: '15%'
  },
  {
    field: 'inspectionDate',
    label: 'Datum kontroly',
    type: ColumnType.DATE,
    width: '10%'
  },
  {
    field: 'result.id',
    displayField: 'result',
    sortable: true,
    filterable: true,
    filterItems: InspectionResultEnum,
    filterBy: { type: ColumnType.ENUM, field: 'result.name', values:
          Object.keys(InspectionResult).reduce((acc, key) => {
            acc[key] = { operation: FilterOperation.EQ, value: key };
            return acc;
          }, {})
    },
    label: 'Výsledek kontroly',
    type: ColumnType.JSX,
    jsx: (row) => {
      const resultSymbol = InspectionResultSymbol[row.result] ? InspectionResultSymbol[row.result] : '';
      const styles = {
        fontSize: 15,
        paddingLeft: 5,
        fontWeight: 600,
        color: row.result === InspectionResult.OK ? '#006505' : row.result === InspectionResult.PROBLEM ? '#ab0c00' : 'black'
      };
      return <span style={styles}>{resultSymbol}</span>;
    },
    width: '5%'
  },
  {
    sortable: false,
    field: 'forwardedTo.name',
    displayField: 'forwardedTo',
    filterBy: { type: ColumnType.TEXT, field: 'forwardedTo', operation: FilterOperation.CONTAINS },
    label: 'Předáno přestupkovému orgánu',
    type: ColumnType.TEXT,
    mapper: field => field ? field.name : '',
    width: '20%'
  }
];

export const InspectionStatementsGrid = props => {
  const columns = [
    ...INSPECTION_GRID_BASE_COLUMNS
  ];

  return <CommonGrid {...props} columns={columns}/>;
}

export const InspectionWorkingPositionGrid = props => {
  const columns = [
    ...INSPECTION_GRID_BASE_COLUMNS,
    {
      field: 'periodFrom',
      label: 'Období od',
      type: ColumnType.DATE,
      width: '10%',
    },
    {
      field: 'periodTo',
      label: 'Období do',
      type: ColumnType.DATE,
      width: '10%'
    }
  ];

  return <CommonGrid {...props} columns={columns}/>;
}